import { type WithChildren } from "@common/declarations";
import { identity } from "lodash";
import React from "react";

export interface RichEditorContextProps {
  hasOpenModal: boolean;
  isCodeview: boolean;
  isFullScreen: boolean;
  setHasOpenModal: (hasOpenModal: boolean) => void;
  toggleCodeview: () => void;
  toggleFullScreen: () => void;
}

export const RichEditorContext = React.createContext<RichEditorContextProps>({
  hasOpenModal: false,
  isCodeview: false,
  isFullScreen: false,
  setHasOpenModal: identity,
  toggleCodeview: identity,
  toggleFullScreen: identity
});

export const RichEditorContextProvider = (props: WithChildren) => {
  const [hasOpenModal, setHasOpenModal] = React.useState(false);
  const [isCodeview, setIsCodeview] = React.useState(false);
  const [isFullScreen, setIsFullScreen] = React.useState(false);

  const contextValue = React.useMemo<RichEditorContextProps>(() => {
    return {
      hasOpenModal,
      isCodeview,
      isFullScreen,
      setHasOpenModal: (hasOpenModal: boolean) => setHasOpenModal(hasOpenModal),
      toggleCodeview: () => setIsCodeview(!isCodeview),
      toggleFullScreen: () => setIsFullScreen(!isFullScreen)
    };
  }, [hasOpenModal, isCodeview, isFullScreen]);

  return <RichEditorContext.Provider value={contextValue}>{props.children}</RichEditorContext.Provider>;
};
